import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  PlaceholderPageSettingsIcon,
  PlaceholderPageContainer,
  PlaceholderPageText,
} from './PlaceholderPage.styles';
interface PlaceholderPageProps {
  pageName: string
}
const PlaceholderPage = ({ pageName }: PlaceholderPageProps) => {
  const { t } = useTranslation('pages');
  return (
    <PlaceholderPageContainer>
      <PlaceholderPageSettingsIcon src="/icons/settings.svg" alt="settings" />
      <PlaceholderPageText textType="primary">{t('placeholder.inDevelopment', { pageName })}</PlaceholderPageText>
      <PlaceholderPageText textType="secondary">{t('placeholder.comingSoon')}</PlaceholderPageText>
    </PlaceholderPageContainer>
  );
};
export default PlaceholderPage;
